 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"ConfirmRessetPassword":"ConfirmRessetPassword","commodity~markets~optimizer":"commodity~markets~optimizer","commodity":"commodity","markets":"markets","optimizer":"optimizer","edituser":"edituser","multi-asset":"multi-asset","polyfills-core-js":"polyfills-core-js","polyfills-css-shim":"polyfills-css-shim","polyfills-dom":"polyfills-dom","profile":"profile","reports":"reports","tools":"tools","tutorials":"tutorials"}[chunkId]||chunkId) + "." + {"ConfirmRessetPassword":"7ab8163f","chunk-0fa41978":"315a061a","chunk-13279a6d":"95249492","chunk-149e29c7":"9dd9a3c8","chunk-1592f06a":"a16b1490","chunk-1fede08f":"3b5a6972","chunk-022b3d6f":"5881b675","chunk-0879684e":"c28b303e","chunk-2d209182":"b738eb34","chunk-395049af":"e39ec833","chunk-4d1b8c7c":"ca4af67e","chunk-2d0e6487":"05a465c1","chunk-2d2105ef":"34bf93b5","chunk-2d226365":"3afe3b37","chunk-6b843f6e":"29a3ad96","chunk-6c110b70":"ea933e19","chunk-affacd6a":"ff500c17","chunk-30b2868b":"03a5194e","chunk-2d0d7838":"bcd5ab01","chunk-ccbe333a":"de85b608","chunk-ccc14c7e":"ffd906b4","chunk-cce8fcde":"fdb39071","chunk-cce9d2cc":"b3bb556d","chunk-a87627ae":"1b906db1","chunk-2d0b722b":"9ac3aa8c","chunk-2d0bad0a":"c16152d3","chunk-2d0dd0bc":"f8389f3c","chunk-2d208de0":"dbdd8cbd","chunk-2d216d99":"ec0017ca","chunk-2d228cf2":"10c31801","chunk-2d22c8fe":"54f81946","chunk-2d23154f":"93cf12de","chunk-38e9ccbe":"042359ef","chunk-3cd6f1d1":"bbdb60e4","chunk-3cd7511d":"c4e568fc","chunk-744d3a45":"186b7b9f","chunk-934214d4":"8828cf26","chunk-a40826f2":"b05159ef","chunk-2d222767":"bd714b53","chunk-c78f05ee":"19fd8a0a","commodity~markets~optimizer":"cb462aab","commodity":"ef773c00","markets":"1a861a25","optimizer":"1867477c","edituser":"ab615635","multi-asset":"ccbd58e5","polyfills-core-js":"f6039027","polyfills-css-shim":"78f54a4c","polyfills-dom":"9cde2f64","profile":"57560e0f","reports":"0c0a5c85","tools":"d539f8d5","tutorials":"ed4c89f6"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"ConfirmRessetPassword":1,"chunk-0fa41978":1,"chunk-934214d4":1,"chunk-a40826f2":1,"chunk-c78f05ee":1,"commodity":1,"markets":1,"optimizer":1,"edituser":1,"tutorials":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"ConfirmRessetPassword":"ConfirmRessetPassword","commodity~markets~optimizer":"commodity~markets~optimizer","commodity":"commodity","markets":"markets","optimizer":"optimizer","edituser":"edituser","multi-asset":"multi-asset","polyfills-core-js":"polyfills-core-js","polyfills-css-shim":"polyfills-css-shim","polyfills-dom":"polyfills-dom","profile":"profile","reports":"reports","tools":"tools","tutorials":"tutorials"}[chunkId]||chunkId) + "." + {"ConfirmRessetPassword":"ab333bd8","chunk-0fa41978":"185d4fa2","chunk-13279a6d":"31d6cfe0","chunk-149e29c7":"31d6cfe0","chunk-1592f06a":"31d6cfe0","chunk-1fede08f":"31d6cfe0","chunk-022b3d6f":"31d6cfe0","chunk-0879684e":"31d6cfe0","chunk-2d209182":"31d6cfe0","chunk-395049af":"31d6cfe0","chunk-4d1b8c7c":"31d6cfe0","chunk-2d0e6487":"31d6cfe0","chunk-2d2105ef":"31d6cfe0","chunk-2d226365":"31d6cfe0","chunk-6b843f6e":"31d6cfe0","chunk-6c110b70":"31d6cfe0","chunk-affacd6a":"31d6cfe0","chunk-30b2868b":"31d6cfe0","chunk-2d0d7838":"31d6cfe0","chunk-ccbe333a":"31d6cfe0","chunk-ccc14c7e":"31d6cfe0","chunk-cce8fcde":"31d6cfe0","chunk-cce9d2cc":"31d6cfe0","chunk-a87627ae":"31d6cfe0","chunk-2d0b722b":"31d6cfe0","chunk-2d0bad0a":"31d6cfe0","chunk-2d0dd0bc":"31d6cfe0","chunk-2d208de0":"31d6cfe0","chunk-2d216d99":"31d6cfe0","chunk-2d228cf2":"31d6cfe0","chunk-2d22c8fe":"31d6cfe0","chunk-2d23154f":"31d6cfe0","chunk-38e9ccbe":"31d6cfe0","chunk-3cd6f1d1":"31d6cfe0","chunk-3cd7511d":"31d6cfe0","chunk-744d3a45":"31d6cfe0","chunk-934214d4":"1158ee4f","chunk-a40826f2":"4270d8a8","chunk-2d222767":"31d6cfe0","chunk-c78f05ee":"0a551c66","commodity~markets~optimizer":"31d6cfe0","commodity":"04714132","markets":"447afbd7","optimizer":"43d8f82a","edituser":"89013a13","multi-asset":"31d6cfe0","polyfills-core-js":"31d6cfe0","polyfills-css-shim":"31d6cfe0","polyfills-dom":"31d6cfe0","profile":"31d6cfe0","reports":"31d6cfe0","tools":"31d6cfe0","tutorials":"5256f319"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([1,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
